import { IUserGroupRoleChanged } from 'APP/model/counter/counterModel.types';
import Entities from 'STORE';

export function updateUserGroupRole(roleChanges: IUserGroupRoleChanged): void {
  const group = Entities.GroupsStore.getGroupById(roleChanges.groupId);
  if (!group) {
    return;
  }

  group.setUserGroupRole(roleChanges.newRole);
  group.messagesStore.messages.forEach((message) => {
    if (message?.threadId) {
      const thread = Entities.GroupsStore.getGroupById(message.threadId);
      if (thread) {
        thread.setUserGroupRole(roleChanges.newRole);
      }
    }
  });
}
